// @flow
import * as React from 'react'
import SVGResponsive, { type PublicProps } from 'icon/SVGResponsive'

type Props = PublicProps & {
  strokeColor: string,
}

export default class MagnifyingGlassIcon extends React.Component<Props> {
  static defaultProps = {
    strokeColor: '#fff',
  }

  render = () => {
    const { strokeColor, ...rest } = this.props
    return (
      <SVGResponsive {...rest} width={22} height={22}>
        <g
          stroke={strokeColor}
          strokeWidth="2"
          transform="translate(1 1)"
          fill="none"
          fillRule="evenodd"
        >
          <circle cx="7.07" cy="7.104" r="6.738" />
          <path d="M11.833 11.867l8.057 8.057" />
        </g>
      </SVGResponsive>
    )
  }
}
